import moment from "moment"

export const formatDate = ( date ) => {
  const newDate = moment(date).format('YYYY-MM-DD')
  
  return newDate
}